/**
 * `Dado` — o span de dado monoespaçado do cartão de Terraform (D13, spec
 * §3): nome de recurso, valor numérico, linha de log. Extraído de
 * `TerraformAdjustCard.tsx` sem mudança de valor para `PainelDeExecucao`
 * também usar — os dois mostram a mesma classe de dado (endereço de
 * recurso, linha bruta do terraform) e não podiam divergir de fonte.
 */
import { Text } from '@mantine/core'

/** JetBrains Mono resolvido (o mesmo literal de `src/theme/index.ts`
 * `fontFamilyMonospace`) — inline, não via token `ff="monospace"`, para o
 * valor não depender de qual tema o `MantineProvider` que envolve o card
 * está usando (ver docs/DESIGN_SYSTEM.md §3, JetBrains Mono é a fonte de
 * DADO: nome de recurso, valor numérico, custo). */
export const FONTE_DADO = '"JetBrains Mono", "Fira Code", monospace'

export function Dado({ children }: { children: React.ReactNode }) {
  return (
    <Text component="span" data-dado size="0.8rem" style={{ fontFamily: FONTE_DADO }}>
      {children}
    </Text>
  )
}
